import React, { useState } from "react";
import Ce from "./components/Ce";
import Co from "./components/Co";
import Ee from "./components/Ee";
import Eo from "./components/Eo";
import "./styles.css";

export default function App() {
  const [tab, setTab] = useState([]);
  const [min, setMin] = useState();
  const [isHidden, setIsHidden] = useState(true);
  const getDataCO = (data) => {
    tab[0] = data;
  };
  const getDataCE = (data) => {
    tab[1] = data;
  };
  const getDataEO = (data) => {
    tab[2] = data;
  };
  const getDataEE = (data) => {
    tab[3] = data;
  };
  return (
    <div className="App">
      <h1>Calculatrice de NCLC tcf Canada</h1>
      <div className="Box">
        <Co onSubmit={getDataCO} />
        <Ce onSubmit={getDataCE} />
        <Eo onSubmit={getDataEO} />
        <Ee onSubmit={getDataEE} />
        <button
          className="final"
          onClick={() => {
            if (tab.length !== 0) {
              setIsHidden(false);
            }
            setMin(Math.min(...tab));
          }}
        >
          NCLC FINAL
        </button>
        {isHidden ? (
          <></>
        ) : (
          <h3 className="result">Votre NCLC final est égale à : {min}</h3>
        )}
      </div>
    </div>
  );
}
